import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type Experiments from '@alltrails/types/Experiments';
import type { UpsellsResponse } from '@alltrails/types/UpsellsResponse';
import { fetchUpsells } from '../utils/upsellRequests';

export type UpsellContentState = {
  data: UpsellsResponse | null;
};

const initialState: UpsellContentState = {
  data: null
};

export const fetchUpsellContent = createAsyncThunk('upsellContent/fetchUpsellContent', (_arg: void, { getState }) => {
  const { experiments } = getState() as { experiments: Experiments };

  return fetchUpsells(experiments);
});

export const upsellContentSlice = createSlice({
  name: 'upsellContent',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUpsellContent.fulfilled, (state, { payload }) => {
      state.data = payload;
    });
  }
});

export default upsellContentSlice.reducer;
